import React, { Component } from "react";
import LayoutBackoffice from "../../header_footer/LayoutBackoffice";

import axios from "axios";
import PropTypes from "prop-types";

import {deleteDataonServer} from '../../../../components/utils/RequestsHelper';

import Modal from 'react-modal';
 
const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};
 
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement(document.getElementById('root'));

class PontoInteresse extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      pontoInteresse: {},
      modalIsOpen: false
    };

    this.openModal = this.openModal.bind(this); 
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }
 
  closeModal() {
    this.setState({modalIsOpen: false});
  }

  componentDidMount = () => {
    this.loadPontoInteresse();
  };

  editButtonClicked = () => {
    this.context.router.history.push("/backoffice/pontos_interesse/editar/"+this.state.pontoInteresse.identifier);
  };

  deleteButtonClicked = () => {
    
    let promiseObj = deleteDataonServer('/api/pontosInteresse/' + this.props.match.params.identifier);
    promiseObj.then(response => {
        if (response !== undefined){
          this.context.router.history.push("/backoffice/pontos_interesse");
        }
    })
    .catch(err => {
        console.log(err);
    });

  };

  loadPontoInteresse = async () => {
    let identifier = this.props.match.params.identifier;
    console.log(identifier);

    let res = {};
    try {
      res = await axios.get("/api/pontosInteresse/" + identifier, {
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf"
        }
      });
    } catch (error) {
      console.log(error);
    }

    let pontoInteresse = res.data.pontoInteresse;
    this.setState({ pontoInteresse });
  };

  render() {
    return (
      <LayoutBackoffice>

        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
 
          <h4>Deseja apagar o Ponto de Interesse?</h4>
          
          <p>Se apagar, não poderá voltar atrás.</p>

          <div className=""> 
            <button
              onClick={this.deleteButtonClicked}
              className="backoffice-btn btn btn-outline-success"
              
            >Sim, Apagar</button>

            <button className="backoffice-btn btn btn-outline-danger" onClick={this.closeModal}>Cancelar</button>
          </div>
          
          
        </Modal>

        <div className="container backoffice-details">
          <div className="div-btn">
            <button
              type="button"
              className="backoffice-btn btn btn-outline-info"
              onClick={this.editButtonClicked}
            >
              Editar
            </button>
            <button
              type="button"
              className="backoffice-btn btn btn-outline-danger"
              onClick={this.openModal}
            >
              Apagar
            </button>
          </div>

          <div>
            <p className="labels">Foto Principal</p>
            <img
              className="backoffice-foto-principal"
              src={this.state.pontoInteresse.mainPhoto}
              alt="Foto Principal"
            />

            <p className="labels">Nome</p>
            <p className="details">{this.state.pontoInteresse.name}</p>

            <p className="labels">Descrição</p>
            <p className="details" dangerouslySetInnerHTML={{__html: this.state.pontoInteresse.description}}></p>

            <p className="labels">Local</p>
            <p className="details">{this.state.pontoInteresse.local}</p>

            <p className="labels">Identificador</p>
            <p className="details">{this.state.pontoInteresse.identifier}</p>
            
            <p className="labels">Outras Fotografias</p>
            <div className="row">
              {this.state.pontoInteresse.photos &&
                this.state.pontoInteresse.photos.map(function(url) {
                  return (
                    <div className="flex-image">
                      <img src={url} alt="Foto Ponto de Interesse" />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </LayoutBackoffice>
    );
  }
}

export default PontoInteresse;
